import request from '@/utils/request'

// 获取路由
export const getRouters = () => {
  return request({
    url: '/wms/getRouters',
    method: 'get'
  })
}
//获取平台
export const getPlatform = () => {
  return request({
    url: '/sys/getPlatform',
    method: 'get'
  })
}
//获取运输方式
export const getTransportation = () => {
  return request({
    url: '/sys/getTransportMethod',
    method: 'get'
  })
}
export const getOrders = () => {
  return request({
    url: '/orders/getOrders',
    method: 'get'
  })
}